import { PendencyModel, OpenBankingPendency } from '@src/core/domain/dashboard/dashboard.model';
import { Observable } from 'rxjs';

export abstract class PendencyRepository {
  abstract getPendency(): Observable<PendencyModel>;
  abstract getOpenBankingPendencies(): Observable<OpenBankingPendency[]>;
  abstract getTemFibraFacil(): Observable<boolean>;
}
